export const isSameBusiness = (businessId?: string, otherBusinessId?: string) =>
  Boolean(
    businessId &&
      otherBusinessId &&
      businessId.toLowerCase() === otherBusinessId.toLowerCase()
  );
